export default __webpack_public_path__ + "static/article-easy-interior-design-ideas-a9890cfdd54596daaa05187824fe9c37.jpg";